import * as React from 'react';
import { SVGProps } from 'react';

export const CreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.86196 4.26563H21.1388C21.1388 4.26563 22.5447 4.26562 22.5447 5.67153V18.3247C22.5447 18.3247 22.5447 19.7306 21.1388 19.7306H2.86196C2.86196 19.7306 1.45605 19.7306 1.45605 18.3247V5.67153C1.45605 5.67153 1.45605 4.26563 2.86196 4.26563Z"
      stroke="black"
      strokeWidth="1.38"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.45605 8.48438H22.5447"
      stroke="black"
      strokeWidth="1.38"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.67383 12.7031H13.4063"
      stroke="black"
      strokeWidth="1.38"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.67383 15.5156H10.5945"
      stroke="black"
      strokeWidth="1.38"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CreditCard;
